import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../../../utils/api";
import {
  isTutorApproved,
  mergeProspectStatusIntoUser,
} from "../../../utils/tutorProspectStatus";
import { ApprovalMessageSection } from "./ApprovalMessageSection";
import { AvailabilitySection } from "./AvailabilitySection";
import { DashboardPreviewSection } from "./DashboardPreviewSection";
import { TipsForSuccessSection } from "./TipsForSuccessSection";

const UNDER_REVIEW_STATUSES = new Set(["pending", "awaiting_interview"]);

export const StartTeachingPage = () => {
  const navigate = useNavigate();
  const [isApproved, setIsApproved] = useState(false);

  useEffect(() => {
    let active = true;

    const resolveReadyToTeachAccess = (user) => {
      if (!active) return;
      const status = String(user?.prospectStatus || "");
      if (user?.hasPendingProfileUpdate || UNDER_REVIEW_STATUSES.has(status)) {
        navigate("/verify-identity", {
          replace: true,
          state: { showProfileUnderReview: true },
        });
        return;
      }

      if (isTutorApproved(user)) {
        setIsApproved(true);
        return;
      }

      navigate("/create-profile", { replace: true });
    };

    const checkProfileStatus = async () => {
      let user;
      try {
        user = JSON.parse(localStorage.getItem("user") || "{}");
      } catch {
        navigate("/signin", { replace: true });
        return;
      }

      const userId = user?.userId || user?.id;
      if (!userId) {
        navigate("/signin", { replace: true });
        return;
      }

      try {
        const statusPayload = await apiRequest(
          `/api/v1/onboarding/status/${userId}`,
          { method: "GET" },
        );
        user = mergeProspectStatusIntoUser(user, statusPayload);
        localStorage.setItem("user", JSON.stringify(user));
      } catch {
        // Fall back to the last stored status and keep this route fail-closed.
      }

      resolveReadyToTeachAccess(user);
    };

    checkProfileStatus();
    return () => {
      active = false;
    };
  }, [navigate]);

  if (!isApproved) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f5f7fa]">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-brand-medium-blue border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen bg-white">
      <AvailabilitySection />
      <ApprovalMessageSection />
      <DashboardPreviewSection />
      <TipsForSuccessSection />
    </div>
  );
};
